import React from "react";
import { actions } from "primarycare-binder";
import { connect } from "react-redux";
import qdmstyles from "./styles.json";
import { withRouter } from "react-router-dom";

import {
  Container,
  Card,
  Icons,
  H6,
  Text,
  Div,
  Avatar,
  Button,
} from "qdm-component-library";

class YourAppointmentHasBeenBooked extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  changeState = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  componentDidMount() {}

  shouldComponentUpdate(props, state) {
    return true;
  }

  render() {
    return (
      <div>
        <Container
          key={"0"}
          name={"container"}
          fluid={false}
          style={qdmstyles.HtBRj}
        >
          <Card key={"0"} children={"Card"} style={qdmstyles.MAPVN}>
            <Icons
              key={"0"}
              fontIcon={"check"}
              ariaHidden={"true"}
              size={"medium"}
              style={qdmstyles.___f_fcc}
            ></Icons>

            <H6
              key={"1"}
              name={"Your visit has been registered !"}
              style={qdmstyles.db_db_fef__bdbb}
            ></H6>

            <Text
              key={"2"}
              name={
                "Confirmation has been sent to +91 9988774455,+91 8877445511 & Sudharsan@mail.com,rajesh23@mail.com"
              }
              style={qdmstyles.abb_db_c_ab_abcfe}
            ></Text>

            <Div key={"3"} className={"qdm"} style={qdmstyles.faiUY}>
              <Div key={"0"} className={"qdm"} style={qdmstyles.UhwT}>
                <Div
                  key={"0"}
                  className={"qdm"}
                  style={qdmstyles.f__f__edabafa}
                >
                  <Div key={"0"}>
                    <Avatar key={"0"}></Avatar>
                  </Div>

                  <Div key={"1"}>
                    <H6
                      key={"0"}
                      name={"Dr. Priya Dharshini"}
                      style={{ fontSize: "14px" }}
                    ></H6>

                    <Text
                      key={"1"}
                      name={"General Physician"}
                      style={qdmstyles.BtFEO}
                    ></Text>

                    <H6
                      key={"2"}
                      name={"apollo hospital mount road"}
                      style={qdmstyles.vQIA}
                    ></H6>
                  </Div>
                </Div>
              </Div>

              <Div key={"1"} className={"qdm"} style={qdmstyles.XXeJ}>
                <Div
                  key={"0"}
                  className={"qdm"}
                  style={qdmstyles.cbb_a__af_dfc}
                >
                  <Div key={"0"}>
                    <Avatar key={"0"}></Avatar>
                  </Div>

                  <Div key={"1"}>
                    <H6
                      key={"0"}
                      name={"Dr. Priya Dharshini"}
                      style={{ fontSize: "14px" }}
                    ></H6>

                    <Text
                      key={"1"}
                      name={"General Physician"}
                      style={qdmstyles.Nal}
                    ></Text>

                    <H6
                      key={"2"}
                      name={"apollo hospital mount road"}
                      style={qdmstyles.piJT}
                    ></H6>
                  </Div>
                </Div>
              </Div>
            </Div>

            <Div
              key={"4"}
              className={"qdm"}
              style={qdmstyles.faec_b_af_a_adaccd}
            >
              <Div key={"0"} className={"qdm"} style={qdmstyles.aa_fc__a_dfcc}>
                <Text key={"0"} name={"S NO"} style={qdmstyles.KOPD}></Text>

                <Text
                  key={"1"}
                  name={"APPOINTMENT NUMBER"}
                  style={qdmstyles.kqH}
                ></Text>

                <Text
                  key={"2"}
                  name={"DATE &TIME"}
                  style={qdmstyles.IIMlT}
                ></Text>
              </Div>

              <Div key={"1"} className={"qdm"} style={qdmstyles.dd_e_ac_be_fdd}>
                <Text key={"0"} name={"01"} style={qdmstyles.TsJR}></Text>

                <Text
                  key={"1"}
                  name={"AP-123457"}
                  style={qdmstyles.Iwjd}
                ></Text>

                <Text
                  key={"2"}
                  name={"30 Apr 2021 , 09:00 am"}
                  style={qdmstyles.umckV}
                ></Text>
              </Div>

              <Div key={"2"} className={"qdm"} style={qdmstyles.UgA}>
                <Text key={"0"} name={"02"} style={qdmstyles.dJl}></Text>

                <Text
                  key={"1"}
                  name={"AP-123457"}
                  style={qdmstyles.SNLao}
                ></Text>

                <Text
                  key={"2"}
                  name={"30 Apr 2021 , 09:00 am"}
                  style={qdmstyles.CMHUc}
                ></Text>
              </Div>
            </Div>

            <Div
              key={"5"}
              className={"qdm"}
              style={qdmstyles.aad_c_b_ace_babbab}
            >
              <Div key={"0"}>
                <Icons
                  key={"0"}
                  fontIcon={"download"}
                  ariaHidden={"true"}
                  size={"medium"}
                  style={qdmstyles.ebdef_bb_d_aebe_dfdf}
                ></Icons>

                <Text
                  key={"1"}
                  name={"Appointment Summary"}
                  style={qdmstyles.e_a_a_bbe_ebf}
                ></Text>
              </Div>

              <Div key={"1"}>
                <Icons
                  key={"0"}
                  fontIcon={"download"}
                  ariaHidden={"true"}
                  size={"medium"}
                  style={qdmstyles.aAbvO}
                ></Icons>

                <Text key={"1"} name={"Invoice"} style={qdmstyles.JjUGq}></Text>
              </Div>

              <Div key={"2"}>
                <Icons
                  key={"0"}
                  fontIcon={"Add print"}
                  ariaHidden={"true"}
                  size={"medium"}
                  style={qdmstyles.PzNtk}
                ></Icons>

                <Icons
                  key={"1"}
                  fontIcon={"Add print"}
                  ariaHidden={"true"}
                  size={"medium"}
                  style={qdmstyles.ZCU}
                ></Icons>

                <Icons
                  key={"2"}
                  fontIcon={"print"}
                  ariaHidden={"true"}
                  size={"medium"}
                  style={qdmstyles.ga}
                ></Icons>

                <Text
                  key={"3"}
                  name={"Print"}
                  style={qdmstyles.fff_a__bc_eedc}
                ></Text>
              </Div>

              <Div key={"3"}>
                <Icons
                  key={"0"}
                  fontIcon={"share"}
                  ariaHidden={"true"}
                  size={"medium"}
                  style={qdmstyles.BcQ}
                ></Icons>

                <Text key={"1"} name={"Share"} style={qdmstyles.RJqB}></Text>
              </Div>
            </Div>

            <Button
              key={"6"}
              type={"button"}
              variant={"outlined"}
              name={"Back to Home"}
              style={qdmstyles.cf_c_cbb_fd_eaeffa}
            ></Button>

            <Text
              key={"7"}
              name={"Want to cancel appointment ?  Click here"}
              style={qdmstyles.cd_cc_e_aab_fdef}
            ></Text>
          </Card>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(
  mapStateToProps,
  actions
)(withRouter(YourAppointmentHasBeenBooked));
